import React, { useEffect } from 'react'
import NavbarTop from '../components/global/NavbarTop'
// import Footer from './../components/global/Footer';
// import NavbarBottom from '../components/global/NavbarBottom';
import CaseStudiesContent from '../components/CaseStudies/CaseStudiesContent';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from './../redux/language/selector';

const CaseStudies = () => {
  const {t} = useTranslation()

  const language = useSelector(selectLanguage)

  useEffect(() => {
    document.title = t('case-studies-page.case-studies-page-title')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  return (
    <>
        <NavbarTop/>
        <CaseStudiesContent/>
        {/* <Footer/>
        <NavbarBottom/> */}
    </>
  )
}

export default CaseStudies